import { render, staticRenderFns } from "./kv-expandable.vue?vue&type=template&id=4a8df050"
import script from "./kv-expandable.vue?vue&type=script&lang=js"
export * from "./kv-expandable.vue?vue&type=script&lang=js"
import style0 from "./kv-expandable.vue?vue&type=style&index=0&id=4a8df050&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports